import { EnteEsecutore } from "./ente.model";
import { RuoloUtente } from "./utente.ruolo.model";

export class Utente {
    id?: number;
    nome?: string;
    idAuth0?: string;
    password?: string;
    email?: string;
    ruolo?: RuoloUtente;
    enteEsecutore?: EnteEsecutore;

    constructor(data?: Partial<Utente>) {
        Object.assign(this, data);
    }
}
